// mvp-returns Phase H17 — Failed Operations API client
// Endpoints at /ord/failed-operations on de-order-service.

import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export type FailedOpStatus =
  | "PENDING"
  | "RETRYING"
  | "MANUAL_INTERVENTION_REQUIRED"
  | "RESOLVED"
  | "GIVEN_UP";

export interface IFailedOp {
  id: string;
  returnRequestId: string | null;
  // O173 — the return's number (replaces the UUID slice); null when the row has no return.
  returnNumber?: string | null;
  // O172 — false for SLA notices and unlinked restocks: a retry only bounces them back to manual.
  retryable?: boolean;
  operationType: string;
  targetService: string | null;
  retryCount: number;
  maxRetries: number;
  status: FailedOpStatus;
  nextAttemptAt: string;
  lastError: string | null;
  resolvedAt: string | null;
  resolvedByUserId: string | null;
  createdAt: string;
}

export interface IFailedOpsListParams {
  status?: FailedOpStatus | FailedOpStatus[];
  operationType?: string;
  page?: number;
  limit?: number;
}

export interface IFailedOpsListResponse {
  items: IFailedOp[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const list = (params?: IFailedOpsListParams): Promise<IFailedOpsListResponse> =>
  httpRequest.get("/ord/failed-operations", params as never) as Promise<IFailedOpsListResponse>;

export const retryNow = (id: string): Promise<{ id: string; status: string }> =>
  httpRequest.post(`/ord/failed-operations/${id}/retry`, {} as never) as Promise<{ id: string; status: string }>;

export const resolve = (id: string, notes?: string): Promise<{ id: string; status: string }> =>
  httpRequest.post(`/ord/failed-operations/${id}/resolve`, { notes } as never) as Promise<{ id: string; status: string }>;

export const giveUp = (id: string, notes?: string): Promise<{ id: string; status: string }> =>
  httpRequest.post(`/ord/failed-operations/${id}/give-up`, { notes } as never) as Promise<{ id: string; status: string }>;
